function Dropdown({
  label,
  name,
  value,
  onChange,
  options,
  placeholder = "Select an option",
  error,
  hint,
  disabled,
  className = "",
  labelClassName = "",
  onAdd,
  addLabel = "Add New",
}) {
  return (
    <div className="space-y-1">
      {label && (
        <span className={`block text-[11px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 ${labelClassName}`.trim()}>
          {label}
        </span>
      )}
      <div className="flex gap-1.5">
        <div className="relative flex-1">
          <select
            id={name}
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`w-full appearance-none rounded-lg border bg-white px-2 py-1 text-xs text-slate-900 focus:outline-none transition-all focus:ring-2 dark:bg-slate-900 dark:text-slate-100 ${
              error
                ? "border-danger focus:border-danger focus:ring-danger/20"
                : "border-slate-200 focus:border-primary-500 focus:ring-primary-500/20 dark:border-slate-800 dark:focus:border-primary-500 dark:focus:ring-primary-dark/20"
            } ${className}`.trim()}
            style={{
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%2364748b' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
              backgroundPosition: `right 0.5rem center`,
              backgroundRepeat: `no-repeat`,
              backgroundSize: `1.5em 1.5em`,
              paddingRight: `2.5rem`
            }}
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        {onAdd && (
          <button
            type="button"
            onClick={onAdd}
            disabled={disabled}
            className="flex h-[26px] w-[26px] items-center justify-center rounded-lg border border-primary-100 bg-primary-50 text-primary-600 transition-all hover:bg-primary-100 dark:border-primary-900/30 dark:bg-primary-900/20 dark:hover:bg-primary-900/40"
            title={addLabel}
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
            </svg>
          </button>
        )}
      </div>
      {error ? (
        <p className="mt-1 text-xs font-medium text-danger">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-xs text-brand-text-secondary dark:text-slate-400">{hint}</p>
      ) : null}
    </div>
  );
}

export default Dropdown;
